import { RVRoutingPage } from "@regal-voice/ui";

import { LiveOpsSubNav } from "./Components/liveOpsSubNav";
export default function LiveOpsRoutingPage(): JSX.Element {
    return <RVRoutingPage nav={<LiveOpsSubNav />} />;
}
